import { Controller } from 'stimulus';
import $ from 'jquery';

class Modal extends Controller {
  closeModal() {
    this.openValue = false;
  }

  openValueChanged() {
    if(this.openValue) {
      $(this.element).show();
      $('body').addClass('lock');
      $(document).on('keyup.modal', e => {
        // close on 'esc' key
        if(e.keyCode === 27) {
          this.openValue = false;
        }
      });
    }
    else {
      $(this.element).hide();
      $('body').removeClass('lock');
      $(document).off('keyup.modal');
    }
  }
}

Modal.values = {
  open: Boolean,
};

export default Modal;